import React from 'react'
import { Card, Col, Row, Typography } from 'antd'
import IntlMessages from 'util/IntlMessages'

const { Paragraph } = Typography

const Iftar = () => {
	return (
		<Row>
			<Col xl={24} lg={24} md={24} sm={24} xs={24}>
				<Row>
					<Col xl={12} lg={12} md={24} sm={24} xs={24}>
						<Card style={{ width: '100%' }} className='gx-card'>
							<Typography>
								<Paragraph>
									<IntlMessages id='iftar.left.paragraph.1' />
								</Paragraph>
							</Typography>
						</Card>
					</Col>
					<Col xl={12} lg={12} md={24} sm={24} xs={24}>
						<Card style={{ width: '100%' }} className='gx-card'>
							<Typography>
								<Paragraph>
									<IntlMessages id='iftar.right.paragraph.1' />
								</Paragraph>
							</Typography>
						</Card>
					</Col>
				</Row>
			</Col>
		</Row>
	)
}

export default Iftar

// {product.name === 'donation.product.monthly.title' ? (
// 	<div>
// 		<p style={{ paddingBottom: 10 }}>
// 			<IntlMessages id='donation.product.monthly.desc.main.title' />
// 		</p>

// 		<div
// 			style={{
// 				display: 'flex',
// 				flexDirection: 'column',
// 				gap: '-5px',
// 				paddingBottom: '15px'
// 			}}
// 		>
// 			{/* {[1, 2, 3, 4, 5].map((item, index) => (
// 				<p>
// 					<IntlMessages
// 						id={`donation.product.monthly.desc.message.${
// 							index + 1
// 						}`}
// 					/>
// 				</p>
// 			))} */}
// 			<Timeline className='custom-timeline'>
// 				{[1, 2, 3, 4, 5].map((item, index) => (
// 					<Timeline.Item color='green'>
// 						<IntlMessages
// 							id={`donation.product.monthly.desc.message.${index + 1
// 								}`}
// 						/>
// 					</Timeline.Item>
// 				))}
// 			</Timeline>
// 		</div>
// 	</div>
// ) : (
// 	<p style={{ paddingBottom: 10 }}>
// 		{product.description ? (
// 			<IntlMessages id={product.description} />
// 		) : null}
// 	</p>
// )}
// </>
// )}

// <Col xl={24}>
// 										<Card
// 											style={{ width: '100%', height: '90%' }}
// 											className='gx-card'
// 										>
// 											<Typography>
// 												<Paragraph>
// 													<IntlMessages id='donation.product.emergency.left.1' />
// 												</Paragraph>
// 												<Paragraph>
// 													<IntlMessages id='donation.product.emergency.left.2' />
// 												</Paragraph>
// 												<Paragraph>
// 													<IntlMessages id='donation.product.emergency.left.3' />
// 												</Paragraph>
// 												<Paragraph>
// 													<IntlMessages id='donation.product.emergency.left.4' />
// 												</Paragraph>
// 												<Paragraph>
// 													<IntlMessages id='donation.product.emergency.left.5' />
// 												</Paragraph>
// 												<Paragraph>
// 													<IntlMessages id='donation.product.emergency.left.6' />
// 												</Paragraph>
// 											</Typography>
// 										</Card>
// 									</Col>

// <Col xl={24}>
// 										<Card
// 											style={{ width: '100%', height: '90%' }}
// 											className='gx-card'
// 										>
// 											<Typography>
// 												<Paragraph>
// 													<IntlMessages id='donation.product.emergency.desc' />
// 												</Paragraph>
// 												<Paragraph>
// 													<IntlMessages
// 														id={'donation.product.emergency.top.right.1'}
// 													/>
// 												</Paragraph>
// 											</Typography>
// 										</Card>
// 									</Col>
